/**
 * @file   src\components\AgentWantAd\AgentCompensation.js
 * @brief  This file is responsible for agent compensation section in create want ad
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import {
  handleRadioButonChange,
  handleTextBoxChange,
} from "../../actions/common";
import { removeNegativeInput } from "../../helpers/validations";
import {
  capitalizeFirstString,
  handleKeyDownToPreventCharacters,
  handleKeyDownToPreventMinusSign,
  removeDecimalZeros,
  thousandSeperatedValue,
  trimString,
} from "../../helpers/common";
import { FormLabel } from "react-bootstrap";
import TextArea from "../Common/TextArea";
import { ERROR_TEXT } from "../../constants/common";

const AgentCompensation = (props) => {
  const {
    handleFormValues,
    agentCompenation,
    compenationType,
    errors,
    otherConcessions,
  } = props;

  const [compensationTypeList, setCompensationTypeList] = useState([]);
  let isUnCheckItem = false;
  const [selectedValue, setSelectedValue] = useState(compenationType);
  const [compensationError, setCompensationError] = useState("");
  const [otherConcessionError, setOtherConcessionError] = useState(false);
  const [descCursorPos, setDescCursorPos] = useState(0);
  const [descCharCount, setDescCharCount] = useState(0);
  const [description, setDescription] = useState("");
  const OtherConcessionRef = useRef();

  useEffect(() => {
    setDescription(otherConcessions);
    setDescCharCount(
      otherConcessions && otherConcessions.length ? otherConcessions.length : 0,
    );
  }, [otherConcessions, otherConcessionError]);

  useEffect(() => {
    OtherConcessionRef.current.setSelectionRange(descCursorPos, descCursorPos);
  }, [descCursorPos]);

  // to show error message
  useEffect(() => {
    if (errors && errors.length > 0) {
      if (errors[0] == "otherConcession") {
        OtherConcessionRef.current.focus();
      }
      errors.map((item) => {
        if (item === "agentCompenation") {
          setCompensationError(
            compenationType == 1 ? "Enter percentage." : "Enter flat fee.",
          );
        }
        if (item === "otherConcession") setOtherConcessionError(ERROR_TEXT);
      });
    }
  }, [errors]);

  const sentenceCase = (input, lowercaseBefore) => {
    setOtherConcessionError("");
    input = input === undefined || input === null ? "" : input;
    if (lowercaseBefore) {
      input = input.toLowerCase();
    }
    return input
      .toString()
      .replace(/(^|\. *)([a-z])/g, function (match, separator, char) {
        return separator + char.toUpperCase();
      });
  };

  const handleOtherOncessionChange = (e) => {
    let value = capitalizeFirstString(handleTextBoxChange(e));
    value = sentenceCase(value);
    setDescCharCount(value.length);
    setDescription(value);
    if (trimString(value) !== "") {
      handleFormValues({ otherConcessions: value });
      setDescCursorPos(e.target.selectionStart);
    } else {
      handleFormValues({ otherConcessions: "" });
    }
  };

  return (
    <>
      <div className="wantad-timing-wrap pb-0">
        <div className="wantad-des-wrap select-type-wrap ">
          <div className="position-relative">
            <TextArea
              className={
                otherConcessionError != ""
                  ? "form-control txt-area red-marked-formcontrol"
                  : "form-control txt-area "
              }
              errorMessage={otherConcessionError}
              value={description ? description : ""}
              maxLength={500}
              placeholder="Optional: Rate buy down, closing costs, etc."
              onChange={(e) => {
                handleOtherOncessionChange(e);
              }}
              txtRef={OtherConcessionRef}
              onBlur={() => {
                handleFormValues({ focusOut: true });
              }}
            />

            <div
              className={
                otherConcessionError != ""
                  ? "des-count red-marked-count"
                  : "des-count"
              }
            >
              <span>{descCharCount}</span>/<span>500</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AgentCompensation;
